import axios from "axios";
import md5 from "js-md5";
const qs = require("querystring");

// 加密数据
const getToken = (params) => {
  const APP_TOKEN = "TBmMjIwM2";
  const _queryArr = qs.stringify(params).split("");
  const _query = _queryArr.sort().join("");
  const secret = APP_TOKEN + _query;

  return md5(secret);
};

const request = axios.create({
  // 测试地址
  // baseURL:'http://183.193.53.242:52601/',
  // 预发布环境
  // baseURL: 'https://gf60.org.cn:7073/',
  // 生产地址
  // baseURL: 'https://gf60.org.cn:7070/',
  baseURL: "https://www.3lcapital.com.cn:7070/",

  // baseURL:
  //   process.env.NODE_ENV === "production"
  //     ? "https://gf60.org.cn:7070/"
  //     : "http://192.168.39.40:7071/",
  // baseURL:
  //   process.env.NODE_ENV === "production"
  //     ? "https://gf60.org.cn:7070/"
  //     : "http://192.168.39.40:7071/",

  withCredentials: false,
});

export default function ajax(
  url,
  params = {},
  type = "get",
  errorCallBack,
  config = { headers: { "Content-Type": "application/json" } }
) {
  const _config = { headers: { ...config.headers, token: getToken(params) } };
  let arg = [];
  if (type === "get") {
    arg = [url, { params, ..._config }];
  } else {
    arg = [url, params, _config];
  }
  return new Promise((resolve) => {
    request[type](...arg)
      .then((res) => {
        const { statusCode, model, errMsg, errcode } = res.data;
        if (statusCode === "0000") {
          resolve(model || {});
        } else if (errcode === "0") {
          resolve(res.data);
        } else {
          console.log(errMsg);
        }
      })
      .catch(() => {
        errorCallBack && errorCallBack();
      });
  });
}
